export default __webpack_public_path__ + "media/react.a7e79cc3.svg";